import React from 'react'

const CheckBoxIcon = (props) => {
    const {color, width, height}=props;
    return (
        <svg width={width} height={height} viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="0.5" width="20" height="20" rx="5" stroke= {color} />
        </svg>
    )
}

export default CheckBoxIcon